<template>
    <div class="page">
        <transition name="fade">
            <div class="list" @click="animationend">
                <div class="main">
                    <div class="body"></div>
                    <div class="text">
                        <div
                            class="text-wrap"
                            v-if="textShow">
                            <span
                                class="t"
                                v-for="(t,index) in text"
                                :key="index"
                                :style="tStyle(index)">
                                {{t}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="wenwu">
                    <img :src="item.icon" alt="" v-for="(item,key) in gameInfo" :key="key" class="icon">
                </div>
                <p class="tip">点击继续</p>
            </div>
        </transition>
        <game-start @changeBgAudio="changeBgAudio" ref="gameStart"/>
    </div>
</template>

<script>
import wxShare from '@utils/wxShare';
import gameInfo from './assets/gameInfo';
import GameStart from './components/GameStart';

export default {
    components: {
        GameStart
    },
    data() {
        return {
            textList: [
                '超凡的眼力是成为出色鉴宝师的基础，三期的锻炼还远远不够，百炼成钢，继续鉴宝师养成基础篇，眼力养成。',
                '沉淀百年，留存城市印记。跨越千载，传承文明守望。走进中国天津博物馆，探寻华夏荣光，开启文物传奇。'
            ],
            text: '超凡的眼力是成为出色鉴宝师的基础，三期的锻炼还远远不够，百炼成钢，继续鉴宝师养成基础篇，眼力养成。',
            textShow: true
        };
    },
    computed: {
        gameInfo() {
            return gameInfo.tianjin.info;
        }
    },
    mounted() {
        this.$emit('changeBgAudio', 'bgm');
        const time = ((this.textList[0].length / 8) + 1.6) * 1000;
        // const time2 = ((this.textList[1].length / 8) + 0.8) * 1000;
        setTimeout(() => {
            this.textShow = false;
            setTimeout(() => {
                this.text = '沉淀百年，留存城市印记。跨越千载，传承文明守望。走进中国天津博物馆，探寻华夏荣光，开启文物传奇。';
                this.textShow = true;
            }, 0);
        }, time);
        // setTimeout(() => {
        //     if (this.$refs.gameStart) {
        //         this.$refs.gameStart.show();
        //     }
        // }, time + time2);
        wxShare({
            title: '鉴宝师培养计划 天津博物馆',
            desc: '如果你天赋异禀，如果你兰质蕙心，如果你颖悟绝伦，皆可免试入门。',
            link: `${location.origin}/guessdifferent`,
            imgUrl: 'https://wwj.jijiagames.com/web/act/20181127/img/index_bg.png'
        }, () => {
            this.$emit('changeBgAudio', 'bgm');
        });
    },
    methods: {
        tStyle(i) {
            return {
                animationDelay: `${(i / 8) + 0.8}s`
            };
        },
        animationend() {
            this.$refs.gameStart.show();
        },
        changeBgAudio() {
            this.$emit('changeBgAudio', 'gamebgm');
        }
    }
};
</script>

<style lang="stylus" scoped>
.fade-enter-active, .fade-leave-active
    transition opacity .2s
.fade-enter, .fade-leave-to
    opacity 0.5
@keyframes move
    from
        transform translateY(300%)
    to
        transform translateY(0%)
@keyframes show
    from
        opacity 0
    to
        opacity 1
.page
    size 100%
    display flex
    flex-direction column
    justify-content space-around
    align-items center
    background url('./assets/img/game_bg.png') 0 0/100% 100% no-repeat
    .list
        size 100%
        position fixed
        top 0
        left 0
        background #fff
        overflow hidden
        background url('./assets/img/recommend_bg.png') 0 0/100% 100% no-repeat
        .main
            position absolute
            bottom 32%
            left 50%
            transform translateX(-50%)
            .body
                size 3.22rem 3.85rem
                opacity 0
                animation show 1s
                animation-delay .4s
                animation-fill-mode forwards
                background url('./assets/img/body.png') 0 0/100% 100% no-repeat
            .text
                animation show .8s
                animation-delay .8s
                animation-fill-mode forwards
                opacity 0
                position absolute
                left -1rem
                top -3rem
                size 5.27rem 3.81rem
                padding .3rem .68rem 0
                line-height .36rem
                text-align center
                background url('./assets/img/text.png') 0 0/100% 100% no-repeat
                z-index -1
                .text-wrap
                    size 100%
                    .t
                        display inline-block
                        size .32rem
                        font-size .32rem
                        line-height .32rem
                        color #333
                        animation show .5s
                        animation-fill-mode forwards
                        opacity 0
        .wenwu
            size 100% 1.2rem
            padding 0 .2rem
            margin .2rem 0 .3rem
            display flex
            justify-content space-around
            position absolute
            bottom 18%
            left 0
            img
                height 100%
                animation move 1s
                animation-fill-mode forwards
                transform translateY(400%)
                for i in 1 2 3 4 5 6 7 8
                    &:nth-child({i})
                        animation-delay ((i / 2)+3) s
        .tip
            font-size .3rem
            color #e1d6a6
            position absolute
            bottom 10%
            left 50%
            transform translateX(-50%)
            text-align center
</style>
